import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import * as dateFns from "date-fns";

import {
  getDonorBloodType,
  getDonorStatus,
  getStartOfWorkDay,
} from "../../services/helpers";
import TimeSlot from "./TimeSlotContainer";
import Slot from "./Slot";
import TetherComponent from "react-tether";
import OutsideClickHandler from "../common/OutsideClickHandler";
import TimeSlotMenu from "./TimeSlotMenuContainer";
import { setTimeslotMenuIsOpen } from "../../redux/timeslots/actions";

const SlotsRenderer = ({
  appointments,
  sortedTimeslots,
  recourseIndex,
  scrollableArea,
  currentDate,
  timeslotMenuIsOpened,
  onClick,
}) => {
  const dispatch = useDispatch();
  const [openMenuSlotId, setOpenMenuSlotId] = useState(null);

  useEffect(() => {
    if (!timeslotMenuIsOpened) {
      setOpenMenuSlotId(null);
    }
  }, [timeslotMenuIsOpened]);

  const slots = [];
  let delayStart = getStartOfWorkDay(currentDate);

  const sortedAppointments =
    appointments && appointments.length > 1
      ? [...appointments].sort((a, b) => a.startDate - b.startDate)
      : appointments || [];

  for (let i = 0; i < sortedAppointments.length; i++) {
    const {
      appointmentType: { name: type, duration, donorStatus },
      reservation: { user } = { user: {} },
      reservation,
      status,
      donorType,
      startDate,
      endDate,
      bloodTiter,
    } = sortedAppointments[i];

    const toggleMenu = (slotId) => {
      const timeSlot = sortedTimeslots.find(
        (sortedTimeslot) =>
          sortedTimeslot.timeslotId === sortedAppointments[i].timeslotId,
      );
      setOpenMenuSlotId((prev) => (prev === slotId ? null : slotId));
      onClick(timeSlot);
      dispatch(setTimeslotMenuIsOpen());
    };

    const setTimeSlotData = () => {
      const timeSlot = sortedTimeslots.find(
        (sortedTimeslot) =>
          sortedTimeslot.timeslotId === sortedAppointments[i].timeslotId,
      );
      onClick(timeSlot);
    };

    const handleTimeSlotClick = (key) => {
      if (sortedAppointments[i].status === "pending") {
        toggleMenu(key);
      }

      if (sortedAppointments[i].status === "confirmed") {
        setTimeSlotData();
      }
    }

    const [firstname, lastname] = user
      ? [user?.firstname, user?.lastname]
      : ["######", "######"];
    const userName =
      firstname || lastname ? [firstname, lastname].join(" ") : "";
    const currentBloodType = getDonorBloodType(user);
    const currentDonorStatus = getDonorStatus(user);
    const userTitle = user
      ? currentDonorStatus !== "-" && currentBloodType !== "-"
        ? `${currentDonorStatus} donor, ${currentBloodType}`
        : ""
      : "######";

    let delayEnd = startDate;
    let end = endDate;
    const delay = dateFns.differenceInMinutes(delayEnd, delayStart);
    delayStart = end;

    const key = `slot-${recourseIndex}-${i}`;
    const menuClassName =
      openMenuSlotId === key ? "slot-menu menu open" : "slot-menu menu";

    slots.push(
      <TetherComponent
        key={key}
        attachment="middle right"
        targetAttachment="top right"
        constraints={[
          {
            to: scrollableArea,
            attachment: "together",
            pin: true,
          },
        ]}
        renderTarget={(ref) => (
          <>
            <TimeSlot
              scrollableArea={scrollableArea}
              name={userName}
              key={`timeslot_${recourseIndex}_${i}`}
              currentDetails={sortedAppointments[i]}
              currentAppointment={sortedAppointments[i]}
            >
              <div ref={ref} onClick={() => handleTimeSlotClick(key)}>
                <Slot
                  type={type}
                  size={`duration-${Math.round(duration / 60000)}`}
                  delay={`delay-${delay}`}
                  name={userTitle}
                  status={status}
                  bloodTypes={donorType}
                  bloodTiter={bloodTiter}
                  donor={donorStatus}
                  isReservation={!!reservation}
                />
              </div>
            </TimeSlot>
          </>
        )}
        renderElement={(ref) =>
          openMenuSlotId === key && (
            <div ref={ref} className={menuClassName}>
              <OutsideClickHandler
                handleClickOutside={() => toggleMenu(null)}
                closeOnScroll={true}
              >
                <TimeSlotMenu isDayPage />
              </OutsideClickHandler>
            </div>
          )
        }
      />,
    );
  }

  return <>{slots}</>;
};

export default SlotsRenderer;
